import React from 'react';
import { useRecoilState } from 'recoil';
import { Box, Heading, FormControl, FormLabel, Select, HStack, Button, Tooltip, Icon } from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';
import { formDataState } from '../../state/calculatorState';
import { phaseValues } from '../../utils/complexityCalculator';

const TOOLTIPS = {
  phase: 'Expected reservoir fluid phase (Liquid, Two-phase, Vapor, Supercritical)',
  hydroCarbons: 'Presence of hydrocarbons in the reservoir or overburden',
  toxicGas: 'Presence of H2S, CO2, or other toxic gases'
};

const LabelWithInfo = ({ children, tooltip }) => (
  <HStack spacing={1}>
    <span>{children}</span>
    <Tooltip label={tooltip} placement="top" hasArrow>
      <span><Icon as={InfoIcon} boxSize={3} color="gray.400" cursor="help" /></span>
    </Tooltip>
  </HStack>
);

export const WellControlSection = ({ compact }) => {
  const [formData, setFormData] = useRecoilState(formDataState);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleBoolToggle = (field) => {
    setFormData(prev => ({ ...prev, [field]: !prev[field] }));
  };

  return (
    <Box bg="white" p={compact ? 0 : 5} borderRadius={compact ? 0 : 'lg'} boxShadow={compact ? 'none' : 'sm'}>
      {!compact && <Heading size="md" mb={4}>Well Control</Heading>}

      <FormControl mb={3}>
        <FormLabel fontSize="sm" fontWeight="semibold">
          <LabelWithInfo tooltip={TOOLTIPS.phase}>Phase</LabelWithInfo>
        </FormLabel>
        <Select size="sm" value={formData.phase} onChange={(e) => handleChange('phase', e.target.value)}>
          <option value="" disabled>Select...</option>
          {Object.entries(phaseValues).map(([key, { txt }]) => (
            <option key={key} value={key}>{txt}</option>
          ))}
        </Select>
      </FormControl>

      <HStack spacing={2}>
        <Tooltip label={TOOLTIPS.hydroCarbons} placement="top" hasArrow>
          <Button size="xs" role="switch" aria-checked={formData.hydroCarbons} variant={formData.hydroCarbons ? 'solid' : 'outline'} colorScheme={formData.hydroCarbons ? 'blue' : 'gray'} onClick={() => handleBoolToggle('hydroCarbons')}>
            Hydrocarbons
          </Button>
        </Tooltip>
        <Tooltip label={TOOLTIPS.toxicGas} placement="top" hasArrow>
          <Button size="xs" role="switch" aria-checked={formData.toxicGas} variant={formData.toxicGas ? 'solid' : 'outline'} colorScheme={formData.toxicGas ? 'blue' : 'gray'} onClick={() => handleBoolToggle('toxicGas')}>
            Toxic Gases
          </Button>
        </Tooltip>
      </HStack>
    </Box>
  );
};

export default WellControlSection;
